import { render, staticRenderFns } from "./RelatedTools.vue?vue&type=template&id=06414879&"
import script from "./RelatedTools.vue?vue&type=script&lang=js&"
export * from "./RelatedTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports